import React from 'react';
import Page from "../Components/Page";
import UploadedFilesContainer from "../containers/UploadedFilesContainer";

const UploadedFilesPage = () => {
  return (
      <Page>
          <UploadedFilesContainer />
      </Page>
  );
};

export default UploadedFilesPage;